import { useFormikContext } from 'formik'

import { getEntityActionTypeSelectOptions } from '../../Entity'
import { FormFieldsContainer } from '../../Form'
import {
  FormikEntityActionConfigFields,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../Formik'

import { NewsboardPostProfileEditTimeRangeDateFields } from './NewsboardPostProfileEditTimeRangeDateFields'
import { NEWSBOARD_POST_PROFILE_TIME_RANGE_START_FIELD_NAME } from './NewsboardPostProfileEditTimeRangeModal.constants'
import { getNewsboardPostProfileEditTimeRangeEmptyValues } from './NewsboardPostProfileEditTimeRangeModal.utils'

export function NewsboardPostProfileEditTimeRangeModalFields({
  actionTypes = Object.values(getEntityActionTypeSelectOptions()),
  typeSelectProps,
}) {
  const { errors } = useFormikContext()

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: getNewsboardPostProfileEditTimeRangeEmptyValues(),
    })

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          ...typeSelectProps,
          error: errors[NEWSBOARD_POST_PROFILE_TIME_RANGE_START_FIELD_NAME],
          options: actionTypes,
        }}
      >
        <NewsboardPostProfileEditTimeRangeDateFields
          disabled={actionTypeValueIsRemoveAll}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}
